export default function focusInput(queryString: string) {
  const input = <HTMLInputElement>document.querySelector(queryString);
  if (input) {
    input.focus();
  }
}
